import React from "react";
import { Coming } from "../../../components/Coming/Coming";

const Recovery = () => {
  return (
    <div>
      <Coming />
    </div>
  );
};

export default Recovery;
